//VARIABLES

let breakpoint = bsBreakpoints.detectBreakpoint();

/**
 * @description Fonction sticky header
 */
const stickyHeader = () => {
  const header = document.querySelector(".header--spe");
  const carto = document.querySelector(".cartographie") || null;
  const alert = document.querySelector(".popin") || null;

  const searchInput = document.querySelector(".views-exposed-form .form-text");
  searchInput
    ? searchInput.setAttribute("placeholder", "Que recherchez-vous ?")
    : "";

  if (carto) {
    if (breakpoint === "large" || breakpoint === "xLarge") {
      header.classList.add("header--spe--scrolled");
    } else {
      header.classList.add("header--spe--scrolled-sm");
    }
  } else {
    if (breakpoint === "large" || breakpoint === "xLarge") {
      if (
        window.scrollY >= 90 &&
        document.querySelector("body").offsetHeight > window.outerHeight
      ) {
        header.classList.add("header--spe--scrolled");
      } else {
        header.classList.remove("header--spe--scrolled");
      }
    } else {
      if (
        window.scrollY >= 102 &&
        document.querySelector("body").offsetHeight > window.outerHeight
      ) {
        header.classList.add("header--spe--scrolled-sm");
      } else {
        header.classList.remove("header--spe--scrolled-sm");
      }
    }
  }
};

const noLink = () => {
  const nav = document.querySelector("body .menu") || null;
  if (nav) {
    nav.querySelectorAll("a").forEach((link) => {
      if (link.getAttribute("href") === "") {
        link.style.pointerEvents = "none";
      }
    });
  }
};

const init = () => {
  noLink();
  stickyHeader();
  window.addEventListener("scroll", () => {
    stickyHeader();
  });
  window.addEventListener("resize", () => {
    setTimeout(() => {
      breakpoint = bsBreakpoints.detectBreakpoint();
      stickyHeader();
    }, 500);
  });
  window.addEventListener("load", () => {
    setTimeout(() => {
      breakpoint = bsBreakpoints.detectBreakpoint();
      stickyHeader();
    }, 500);
  });
};

const usineActive = document.querySelector("body.usine") || null;
!usineActive ? init() : "";
